
import type { LanguageCode } from './languages';

export const homeTranslations: Record<LanguageCode, Record<string, string>> = {
  en: {
    standardsBadge: 'Engineering Standards',
    titleStart: 'International Pipe Sizing &',
    titleHighlight: 'Hydraulic Analysis',
    titleEnd: 'Engine',
    heroDescription: 'Accurately size commercial pipe diameters, water flow velocity, Reynolds numbers, and Darcy-Weisbach friction head loss across metric and imperial standards with zero server latency.',
    quickPresets: 'Quick Application Presets',
    domesticWater: 'Domestic Water Main (0.5 L/s)',
    chilledWater: 'Chilled Water Branch (3.0 L/s)',
    highRise: 'High-Rise Riser (8.0 L/s)',
    apply: 'Apply',
    tabWater: '1. Water Pipe Sizing',
    tabCopper: '2. Copper Pipe Sizing',
    tabFlow: '3. Flow Rate Calculator',
    tabPressure: '4. Pressure Drop (Darcy)',
    tabVelocity: '5. Pipe Velocity & Standards',
    aboutLabel: 'Standards & Certification',
    aboutTitle: 'About PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com is an independent international mechanical engineering utility for building services consultants, mechanical contractors, and plumbing engineers worldwide.',
    standardsTitle: 'Engineering Standards Consulted',
    standard1: 'Specifications for installations inside buildings conveying water for human consumption.',
    standard2: 'Public Health and Plumbing Engineering.',
    standard3: 'Welded and Seamless Wrought Steel and Stainless Steel Pipe.',
    standard4: 'Standard Specification for Seamless Copper Water Tube (Types K, L, M).',
    noticeTitle: 'ENGINEERING NOTICE:',
    notice: 'Calculations provided by this software are for preliminary engineering design, sizing verification, and educational estimation purposes. Mechanical designs must be verified by a licensed professional engineer in accordance with applicable local building codes.',
    toastDomestic: 'Applied: Domestic Water Main',
    toastChilled: 'Applied: Chilled Water Branch',
    toastHighRise: 'Applied: High-Rise Riser',
  },

  hi: {
    standardsBadge: 'इंजीनियरिंग मानक',
    titleStart: 'अंतरराष्ट्रीय पाइप साइज़िंग और',
    titleHighlight: 'हाइड्रोलिक विश्लेषण',
    titleEnd: 'इंजन',
    heroDescription: 'मीट्रिक और इम्पीरियल मानकों के अनुसार पाइप का व्यास, पानी के प्रवाह की गति, रेनॉल्ड्स संख्या और Darcy-Weisbach घर्षण हेड लॉस की गणना करें।',
    quickPresets: 'त्वरित एप्लिकेशन विकल्प',
    domesticWater: 'घरेलू पानी की मुख्य पाइप (0.5 L/s)',
    chilledWater: 'चिल्ड वॉटर ब्रांच (3.0 L/s)',
    highRise: 'ऊँची इमारत की राइज़र पाइप (8.0 L/s)',
    apply: 'लागू करें',
    tabWater: '1. पानी की पाइप साइज़िंग',
    tabCopper: '2. कॉपर पाइप साइज़िंग',
    tabFlow: '3. फ्लो रेट कैलकुलेटर',
    tabPressure: '4. प्रेशर ड्रॉप (Darcy)',
    tabVelocity: '5. पाइप गति और मानक',
    aboutLabel: 'मानक और प्रमाणन',
    aboutTitle: 'PipeSizingCalculator.com के बारे में',
    aboutDescription: 'PipeSizingCalculator.com एक स्वतंत्र अंतरराष्ट्रीय मैकेनिकल इंजीनियरिंग टूल है, जो बिल्डिंग सर्विस कंसल्टेंट, मैकेनिकल कॉन्ट्रैक्टर और प्लंबिंग इंजीनियरों के लिए बनाया गया है।',
    standardsTitle: 'संदर्भित इंजीनियरिंग मानक',
    standard1: 'इमारतों के अंदर पीने योग्य पानी की आपूर्ति करने वाली पाइप इंस्टॉलेशन के विनिर्देश।',
    standard2: 'पब्लिक हेल्थ और प्लंबिंग इंजीनियरिंग।',
    standard3: 'वेल्डेड और सीमलेस स्टील तथा स्टेनलेस स्टील पाइप।',
    standard4: 'सीमलेस कॉपर वॉटर ट्यूब के लिए मानक विनिर्देश (Type K, L, M)।',
    noticeTitle: 'इंजीनियरिंग सूचना:',
    notice: 'इस सॉफ्टवेयर की गणनाएँ प्रारंभिक इंजीनियरिंग डिज़ाइन, साइज़ सत्यापन और शैक्षणिक अनुमान के लिए हैं। मैकेनिकल डिज़ाइन की जाँच स्थानीय बिल्डिंग कोड के अनुसार लाइसेंस प्राप्त इंजीनियर से कराएँ।',
    toastDomestic: 'लागू किया गया: घरेलू पानी की मुख्य पाइप',
    toastChilled: 'लागू किया गया: चिल्ड वॉटर ब्रांच',
    toastHighRise: 'लागू किया गया: ऊँची इमारत की राइज़र पाइप',
  },

  es: {
    standardsBadge: 'Normas de ingeniería',
    titleStart: 'Dimensionamiento internacional de tuberías y',
    titleHighlight: 'análisis hidráulico',
    titleEnd: 'Engine',
    heroDescription: 'Calcule diámetros de tuberías, velocidad del agua, números de Reynolds y pérdidas de carga por fricción Darcy-Weisbach según sistemas métricos e imperiales.',
    quickPresets: 'Configuraciones rápidas',
    domesticWater: 'Tubería principal doméstica (0.5 L/s)',
    chilledWater: 'Ramal de agua fría (3.0 L/s)',
    highRise: 'Montante de edificio alto (8.0 L/s)',
    apply: 'Aplicar',
    tabWater: '1. Dimensionamiento de tuberías de agua',
    tabCopper: '2. Dimensionamiento de tuberías de cobre',
    tabFlow: '3. Calculadora de caudal',
    tabPressure: '4. Pérdida de presión (Darcy)',
    tabVelocity: '5. Velocidad y normas de tuberías',
    aboutLabel: 'Normas y certificación',
    aboutTitle: 'Acerca de PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com es una herramienta internacional e independiente de ingeniería mecánica para consultores, contratistas e ingenieros de fontanería.',
    standardsTitle: 'Normas de ingeniería consultadas',
    standard1: 'Especificaciones para instalaciones interiores que transportan agua para consumo humano.',
    standard2: 'Ingeniería de salud pública y fontanería.',
    standard3: 'Tuberías de acero y acero inoxidable soldadas y sin soldadura.',
    standard4: 'Especificación estándar para tubos de agua de cobre sin soldadura (tipos K, L, M).',
    noticeTitle: 'AVISO DE INGENIERÍA:',
    notice: 'Los cálculos de este software son para diseño preliminar, verificación de dimensiones y estimaciones educativas. Un ingeniero profesional autorizado debe verificar los diseños conforme a los códigos locales.',
    toastDomestic: 'Aplicado: Tubería principal doméstica',
    toastChilled: 'Aplicado: Ramal de agua fría',
    toastHighRise: 'Aplicado: Montante de edificio alto',
  },

  'zh-CN': {
    standardsBadge: '工程标准',
    titleStart: '国际管道尺寸设计与',
    titleHighlight: '水力分析',
    titleEnd: '引擎',
    heroDescription: '根据公制和英制标准计算商业管道直径、水流速度、雷诺数以及 Darcy-Weisbach 摩擦水头损失。',
    quickPresets: '快速应用预设',
    domesticWater: '家庭供水主管 (0.5 L/s)',
    chilledWater: '冷冻水支管 (3.0 L/s)',
    highRise: '高层建筑立管 (8.0 L/s)',
    apply: '应用',
    tabWater: '1. 给水管尺寸计算',
    tabCopper: '2. 铜管尺寸计算',
    tabFlow: '3. 流量计算器',
    tabPressure: '4. 压力损失 (Darcy)',
    tabVelocity: '5. 管道流速与标准',
    aboutLabel: '标准与认证',
    aboutTitle: '关于 PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com 是一款面向全球建筑服务顾问、机械承包商和管道工程师的独立机械工程工具。',
    standardsTitle: '参考工程标准',
    standard1: '建筑物内供人类饮用水的管道安装规范。',
    standard2: '公共卫生与管道工程。',
    standard3: '焊接和无缝钢管及不锈钢管。',
    standard4: '无缝铜水管标准规范（K、L、M 型）。',
    noticeTitle: '工程声明：',
    notice: '本软件计算结果仅用于初步工程设计、尺寸验证和教育估算。机械设计必须由持证专业工程师按照当地建筑规范进行审核。',
    toastDomestic: '已应用：家庭供水主管',
    toastChilled: '已应用：冷冻水支管',
    toastHighRise: '已应用：高层建筑立管',
  },

  ar: {
    standardsBadge: 'المعايير الهندسية',
    titleStart: 'تحديد أحجام الأنابيب الدولية و',
    titleHighlight: 'التحليل الهيدروليكي',
    titleEnd: 'Engine',
    heroDescription: 'احسب أقطار الأنابيب وسرعة تدفق المياه وأرقام رينولدز وفقدان الضغط بالاحتكاك وفق معايير النظام المتري والإمبراطوري.',
    quickPresets: 'إعدادات التطبيق السريعة',
    domesticWater: 'خط المياه المنزلي (0.5 L/s)',
    chilledWater: 'فرع المياه المبردة (3.0 L/s)',
    highRise: 'أنبوب رأسي لمبنى مرتفع (8.0 L/s)',
    apply: 'تطبيق',
    tabWater: '1. تحديد حجم أنابيب المياه',
    tabCopper: '2. تحديد حجم أنابيب النحاس',
    tabFlow: '3. حاسبة معدل التدفق',
    tabPressure: '4. انخفاض الضغط (Darcy)',
    tabVelocity: '5. سرعة الأنابيب والمعايير',
    aboutLabel: 'المعايير والشهادات',
    aboutTitle: 'حول PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com أداة هندسية ميكانيكية مستقلة للمستشارين والمقاولين ومهندسي السباكة حول العالم.',
    standardsTitle: 'المعايير الهندسية المرجعية',
    standard1: 'مواصفات تركيبات المياه المخصصة للاستهلاك البشري داخل المباني.',
    standard2: 'هندسة الصحة العامة والسباكة.',
    standard3: 'أنابيب الصلب والفولاذ المقاوم للصدأ الملحومة وغير الملحومة.',
    standard4: 'المواصفات القياسية لأنابيب المياه النحاسية غير الملحومة (K وL وM).',
    noticeTitle: 'إشعار هندسي:',
    notice: 'تُستخدم حسابات هذا البرنامج للتصميم الهندسي الأولي والتحقق من الأحجام والتقدير التعليمي. يجب مراجعة التصميمات بواسطة مهندس محترف مرخص وفقاً لقوانين البناء المحلية.',
    toastDomestic: 'تم التطبيق: خط المياه المنزلي',
    toastChilled: 'تم التطبيق: فرع المياه المبردة',
    toastHighRise: 'تم التطبيق: أنبوب المبنى المرتفع',
  },

  fr: {
    standardsBadge: 'Normes d’ingénierie',
    titleStart: 'Dimensionnement international des tuyaux et',
    titleHighlight: 'analyse hydraulique',
    titleEnd: 'Engine',
    heroDescription: 'Calculez les diamètres des conduites, la vitesse de l’eau, les nombres de Reynolds et les pertes de charge Darcy-Weisbach selon les systèmes métrique et impérial.',
    quickPresets: 'Préréglages rapides',
    domesticWater: 'Conduite principale domestique (0.5 L/s)',
    chilledWater: 'Branche d’eau glacée (3.0 L/s)',
    highRise: 'Colonne montante d’immeuble (8.0 L/s)',
    apply: 'Appliquer',
    tabWater: '1. Dimensionnement des conduites d’eau',
    tabCopper: '2. Dimensionnement des conduites en cuivre',
    tabFlow: '3. Calculateur de débit',
    tabPressure: '4. Perte de pression (Darcy)',
    tabVelocity: '5. Vitesse et normes des conduites',
    aboutLabel: 'Normes et certification',
    aboutTitle: 'À propos de PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com est un outil indépendant d’ingénierie mécanique destiné aux consultants, entrepreneurs et ingénieurs en plomberie du monde entier.',
    standardsTitle: 'Normes d’ingénierie consultées',
    standard1: 'Spécifications des installations intérieures transportant de l’eau destinée à la consommation humaine.',
    standard2: 'Santé publique et ingénierie de plomberie.',
    standard3: 'Tuyaux en acier et en acier inoxydable soudés et sans soudure.',
    standard4: 'Spécification standard des tubes d’eau en cuivre sans soudure (types K, L, M).',
    noticeTitle: 'AVIS D’INGÉNIERIE :',
    notice: 'Les calculs de ce logiciel sont destinés à la conception préliminaire, à la vérification des dimensions et à des estimations pédagogiques. Les conceptions doivent être vérifiées par un ingénieur agréé conformément aux codes locaux.',
    toastDomestic: 'Appliqué : conduite principale domestique',
    toastChilled: 'Appliqué : branche d’eau glacée',
    toastHighRise: 'Appliqué : colonne montante',
  },

  pt: {
    standardsBadge: 'Normas de engenharia',
    titleStart: 'Dimensionamento internacional de tubos e',
    titleHighlight: 'análise hidráulica',
    titleEnd: 'Engine',
    heroDescription: 'Calcule diâmetros de tubos, velocidade da água, números de Reynolds e perdas de carga por atrito Darcy-Weisbach nos sistemas métrico e imperial.',
    quickPresets: 'Predefinições rápidas',
    domesticWater: 'Linha principal de água doméstica (0.5 L/s)',
    chilledWater: 'Ramal de água gelada (3.0 L/s)',
    highRise: 'Coluna de edifício alto (8.0 L/s)',
    apply: 'Aplicar',
    tabWater: '1. Dimensionamento de tubos de água',
    tabCopper: '2. Dimensionamento de tubos de cobre',
    tabFlow: '3. Calculadora de vazão',
    tabPressure: '4. Perda de pressão (Darcy)',
    tabVelocity: '5. Velocidade e normas de tubos',
    aboutLabel: 'Normas e certificação',
    aboutTitle: 'Sobre PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com é uma ferramenta independente de engenharia mecânica para consultores, empreiteiros e engenheiros hidráulicos em todo o mundo.',
    standardsTitle: 'Normas de engenharia consultadas',
    standard1: 'Especificações para instalações internas que transportam água para consumo humano.',
    standard2: 'Saúde pública e engenharia hidráulica.',
    standard3: 'Tubos de aço e aço inoxidável soldados e sem costura.',
    standard4: 'Especificação padrão para tubos de água de cobre sem costura (tipos K, L, M).',
    noticeTitle: 'AVISO DE ENGENHARIA:',
    notice: 'Os cálculos deste software destinam-se ao projeto preliminar, verificação de dimensões e estimativas educacionais. Os projetos devem ser verificados por um engenheiro profissional licenciado conforme os códigos locais.',
    toastDomestic: 'Aplicado: linha principal doméstica',
    toastChilled: 'Aplicado: ramal de água gelada',
    toastHighRise: 'Aplicado: coluna de edifício alto',
  },

  bn: {
    standardsBadge: 'ইঞ্জিনিয়ারিং মানদণ্ড',
    titleStart: 'আন্তর্জাতিক পাইপ সাইজিং ও',
    titleHighlight: 'হাইড্রোলিক বিশ্লেষণ',
    titleEnd: 'ইঞ্জিন',
    heroDescription: 'মেট্রিক ও ইম্পেরিয়াল মান অনুযায়ী পাইপের ব্যাস, জলের প্রবাহের গতি, রেনল্ডস সংখ্যা এবং Darcy-Weisbach ঘর্ষণজনিত হেড লস গণনা করুন।',
    quickPresets: 'দ্রুত অ্যাপ্লিকেশন প্রিসেট',
    domesticWater: 'বাড়ির প্রধান জলের পাইপ (0.5 L/s)',
    chilledWater: 'ঠান্ডা জলের শাখা পাইপ (3.0 L/s)',
    highRise: 'উঁচু ভবনের রাইজার পাইপ (8.0 L/s)',
    apply: 'প্রয়োগ করুন',
    tabWater: '1. জলের পাইপ সাইজিং',
    tabCopper: '2. তামার পাইপ সাইজিং',
    tabFlow: '3. প্রবাহের হার ক্যালকুলেটর',
    tabPressure: '4. চাপের ক্ষতি (Darcy)',
    tabVelocity: '5. পাইপের গতি ও মানদণ্ড',
    aboutLabel: 'মানদণ্ড ও সার্টিফিকেশন',
    aboutTitle: 'PipeSizingCalculator.com সম্পর্কে',
    aboutDescription: 'PipeSizingCalculator.com বিশ্বজুড়ে বিল্ডিং সার্ভিস কনসালট্যান্ট, মেকানিক্যাল কন্ট্রাক্টর এবং প্লাম্বিং ইঞ্জিনিয়ারদের জন্য একটি স্বাধীন মেকানিক্যাল ইঞ্জিনিয়ারিং টুল।',
    standardsTitle: 'পরামর্শ নেওয়া ইঞ্জিনিয়ারিং মানদণ্ড',
    standard1: 'ভবনের ভিতরে মানুষের পানীয় জল সরবরাহকারী পাইপ স্থাপনের নির্দিষ্টকরণ।',
    standard2: 'জনস্বাস্থ্য ও প্লাম্বিং ইঞ্জিনিয়ারিং।',
    standard3: 'ওয়েল্ডেড ও সিমলেস স্টিল এবং স্টেইনলেস স্টিল পাইপ।',
    standard4: 'সিমলেস কপার ওয়াটার টিউবের মানক নির্দিষ্টকরণ (Type K, L, M)।',
    noticeTitle: 'ইঞ্জিনিয়ারিং বিজ্ঞপ্তি:',
    notice: 'এই সফটওয়্যারের গণনা প্রাথমিক ডিজাইন, পাইপের মাপ যাচাই এবং শিক্ষামূলক অনুমানের জন্য। স্থানীয় বিল্ডিং কোড অনুযায়ী লাইসেন্সপ্রাপ্ত ইঞ্জিনিয়ারকে ডিজাইন যাচাই করতে হবে।',
    toastDomestic: 'প্রয়োগ করা হয়েছে: বাড়ির প্রধান জলের পাইপ',
    toastChilled: 'প্রয়োগ করা হয়েছে: ঠান্ডা জলের শাখা পাইপ',
    toastHighRise: 'প্রয়োগ করা হয়েছে: উঁচু ভবনের রাইজার পাইপ',
  },

  ru: {
    standardsBadge: 'Инженерные стандарты',
    titleStart: 'Международный подбор размеров труб и',
    titleHighlight: 'гидравлический анализ',
    titleEnd: 'Engine',
    heroDescription: 'Рассчитывайте диаметры труб, скорость воды, числа Рейнольдса и потери напора на трение Darcy-Weisbach в метрической и имперской системах.',
    quickPresets: 'Быстрые настройки',
    domesticWater: 'Основная бытовая водопроводная линия (0.5 L/s)',
    chilledWater: 'Ответвление охлаждённой воды (3.0 L/s)',
    highRise: 'Стояк высотного здания (8.0 L/s)',
    apply: 'Применить',
    tabWater: '1. Подбор водопроводных труб',
    tabCopper: '2. Подбор медных труб',
    tabFlow: '3. Калькулятор расхода',
    tabPressure: '4. Потеря давления (Darcy)',
    tabVelocity: '5. Скорость потока и стандарты',
    aboutLabel: 'Стандарты и сертификация',
    aboutTitle: 'О PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com — независимый международный инструмент механической инженерии для консультантов, подрядчиков и инженеров по сантехнике.',
    standardsTitle: 'Использованные инженерные стандарты',
    standard1: 'Требования к внутренним установкам, транспортирующим питьевую воду.',
    standard2: 'Общественное здравоохранение и сантехническая инженерия.',
    standard3: 'Сварные и бесшовные стальные и нержавеющие трубы.',
    standard4: 'Стандартная спецификация бесшовных медных водопроводных труб (типы K, L, M).',
    noticeTitle: 'ИНЖЕНЕРНОЕ УВЕДОМЛЕНИЕ:',
    notice: 'Расчёты предназначены для предварительного проектирования, проверки размеров и учебных оценок. Проекты должны проверяться лицензированным инженером в соответствии с местными строительными нормами.',
    toastDomestic: 'Применено: бытовая водопроводная линия',
    toastChilled: 'Применено: ответвление охлаждённой воды',
    toastHighRise: 'Применено: стояк высотного здания',
  },

  de: {
    standardsBadge: 'Technische Normen',
    titleStart: 'Internationale Rohrdimensionierung und',
    titleHighlight: 'hydraulische Analyse',
    titleEnd: 'Engine',
    heroDescription: 'Berechnen Sie Rohrdurchmesser, Wassergeschwindigkeit, Reynolds-Zahlen und Darcy-Weisbach-Reibungsverluste nach metrischen und imperialen Standards.',
    quickPresets: 'Schnelle Anwendungsvorlagen',
    domesticWater: 'Hauswasser-Hauptleitung (0.5 L/s)',
    chilledWater: 'Kaltwasser-Abzweig (3.0 L/s)',
    highRise: 'Steigleitung im Hochhaus (8.0 L/s)',
    apply: 'Anwenden',
    tabWater: '1. Wasserrohr-Dimensionierung',
    tabCopper: '2. Kupferrohr-Dimensionierung',
    tabFlow: '3. Durchflussrechner',
    tabPressure: '4. Druckverlust (Darcy)',
    tabVelocity: '5. Rohrgeschwindigkeit und Normen',
    aboutLabel: 'Normen und Zertifizierung',
    aboutTitle: 'Über PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com ist ein unabhängiges internationales Werkzeug für Gebäudetechnikberater, Maschinenbauunternehmen und Sanitäringenieure.',
    standardsTitle: 'Berücksichtigte technische Normen',
    standard1: 'Anforderungen an Installationen in Gebäuden zur Förderung von Trinkwasser.',
    standard2: 'Öffentliche Gesundheit und Sanitärtechnik.',
    standard3: 'Geschweißte und nahtlose Stahl- und Edelstahlrohre.',
    standard4: 'Standardspezifikation für nahtlose Kupferwasserrohre (Typen K, L, M).',
    noticeTitle: 'TECHNISCHER HINWEIS:',
    notice: 'Die Berechnungen dienen der Vorplanung, Größenprüfung und Ausbildung. Mechanische Entwürfe müssen von einem zugelassenen Ingenieur gemäß den örtlichen Bauvorschriften geprüft werden.',
    toastDomestic: 'Angewendet: Hauswasser-Hauptleitung',
    toastChilled: 'Angewendet: Kaltwasser-Abzweig',
    toastHighRise: 'Angewendet: Hochhaus-Steigleitung',
  },

  ja: {
    standardsBadge: 'エンジニアリング規格',
    titleStart: '国際的な配管サイズ設計と',
    titleHighlight: '水力解析',
    titleEnd: 'エンジン',
    heroDescription: 'メートル法とヤード・ポンド法の規格に基づき、管径、水流速度、レイノルズ数、Darcy-Weisbach 摩擦損失水頭を計算します。',
    quickPresets: 'クイック設定',
    domesticWater: '家庭用給水主管 (0.5 L/s)',
    chilledWater: '冷水分岐管 (3.0 L/s)',
    highRise: '高層ビル立管 (8.0 L/s)',
    apply: '適用',
    tabWater: '1. 給水管サイズ計算',
    tabCopper: '2. 銅管サイズ計算',
    tabFlow: '3. 流量計算',
    tabPressure: '4. 圧力損失 (Darcy)',
    tabVelocity: '5. 管内流速と規格',
    aboutLabel: '規格と認証',
    aboutTitle: 'PipeSizingCalculator.com について',
    aboutDescription: 'PipeSizingCalculator.com は、世界中の建築設備コンサルタント、機械設備業者、配管技術者向けの独立した機械工学ツールです。',
    standardsTitle: '参照したエンジニアリング規格',
    standard1: '人が飲用する水を建物内で供給する設備の仕様。',
    standard2: '公衆衛生および配管工学。',
    standard3: '溶接鋼管、継目無鋼管およびステンレス鋼管。',
    standard4: '継目無銅製給水管の標準仕様（K、L、Mタイプ）。',
    noticeTitle: 'エンジニアリング上の注意：',
    notice: '本ソフトウェアの計算は予備設計、サイズ確認、教育目的の推定用です。設計は地域の建築基準に従い、資格を持つ技術者が確認してください。',
    toastDomestic: '適用済み：家庭用給水主管',
    toastChilled: '適用済み：冷水分岐管',
    toastHighRise: '適用済み：高層ビル立管',
  },

  ko: {
    standardsBadge: '엔지니어링 표준',
    titleStart: '국제 배관 사이징 및',
    titleHighlight: '수리 분석',
    titleEnd: '엔진',
    heroDescription: '미터법과 야드파운드법 표준에 따라 배관 직경, 물의 유속, 레이놀즈 수 및 Darcy-Weisbach 마찰 수두 손실을 계산합니다.',
    quickPresets: '빠른 설정',
    domesticWater: '가정용 급수 주관 (0.5 L/s)',
    chilledWater: '냉수 분기 배관 (3.0 L/s)',
    highRise: '고층 건물 입상관 (8.0 L/s)',
    apply: '적용',
    tabWater: '1. 급수관 사이징',
    tabCopper: '2. 구리관 사이징',
    tabFlow: '3. 유량 계산기',
    tabPressure: '4. 압력 손실 (Darcy)',
    tabVelocity: '5. 배관 유속 및 표준',
    aboutLabel: '표준 및 인증',
    aboutTitle: 'PipeSizingCalculator.com 소개',
    aboutDescription: 'PipeSizingCalculator.com은 전 세계 건축 설비 컨설턴트, 기계 시공업체 및 배관 엔지니어를 위한 독립적인 기계공학 도구입니다.',
    standardsTitle: '참고한 엔지니어링 표준',
    standard1: '건물 내부에서 음용수를 운반하는 설비에 대한 사양.',
    standard2: '공중 보건 및 배관 엔지니어링.',
    standard3: '용접 및 무계목 강관과 스테인리스강관.',
    standard4: '무계목 구리 급수관 표준 규격 (K, L, M 유형).',
    noticeTitle: '엔지니어링 안내:',
    notice: '이 소프트웨어의 계산은 예비 설계, 치수 검증 및 교육용 추정에 사용됩니다. 설계는 현지 건축 법규에 따라 면허를 보유한 전문 엔지니어가 검토해야 합니다.',
    toastDomestic: '적용됨: 가정용 급수 주관',
    toastChilled: '적용됨: 냉수 분기 배관',
    toastHighRise: '적용됨: 고층 건물 입상관',
  },

  tr: {
    standardsBadge: 'Mühendislik Standartları',
    titleStart: 'Uluslararası Boru Boyutlandırma ve',
    titleHighlight: 'Hidrolik Analiz',
    titleEnd: 'Motoru',
    heroDescription: 'Metrik ve emperyal standartlara göre boru çaplarını, su akış hızını, Reynolds sayılarını ve Darcy-Weisbach sürtünme yük kaybını hesaplayın.',
    quickPresets: 'Hızlı Uygulama Ayarları',
    domesticWater: 'Evsel Ana Su Hattı (0.5 L/s)',
    chilledWater: 'Soğutulmuş Su Dalı (3.0 L/s)',
    highRise: 'Yüksek Bina Kolon Hattı (8.0 L/s)',
    apply: 'Uygula',
    tabWater: '1. Su Borusu Boyutlandırma',
    tabCopper: '2. Bakır Boru Boyutlandırma',
    tabFlow: '3. Debi Hesaplayıcı',
    tabPressure: '4. Basınç Kaybı (Darcy)',
    tabVelocity: '5. Boru Hızı ve Standartları',
    aboutLabel: 'Standartlar ve Sertifikasyon',
    aboutTitle: 'PipeSizingCalculator.com Hakkında',
    aboutDescription: 'PipeSizingCalculator.com, dünya genelindeki yapı hizmetleri danışmanları, mekanik yükleniciler ve tesisat mühendisleri için bağımsız bir mühendislik aracıdır.',
    standardsTitle: 'Başvurulan Mühendislik Standartları',
    standard1: 'Binalarda insan tüketimine yönelik su taşıyan tesisatların özellikleri.',
    standard2: 'Halk sağlığı ve sıhhi tesisat mühendisliği.',
    standard3: 'Kaynaklı ve dikişsiz çelik ve paslanmaz çelik borular.',
    standard4: 'Dikişsiz bakır su boruları için standart şartname (K, L, M tipleri).',
    noticeTitle: 'MÜHENDİSLİK BİLDİRİMİ:',
    notice: 'Bu yazılımın hesaplamaları ön tasarım, boyut doğrulama ve eğitim amaçlı tahminler içindir. Tasarımlar yerel yapı kurallarına göre lisanslı bir mühendis tarafından doğrulanmalıdır.',
    toastDomestic: 'Uygulandı: Evsel ana su hattı',
    toastChilled: 'Uygulandı: Soğutulmuş su dalı',
    toastHighRise: 'Uygulandı: Yüksek bina kolon hattı',
  },

  vi: {
    standardsBadge: 'Tiêu chuẩn kỹ thuật',
    titleStart: 'Tính kích thước đường ống quốc tế và',
    titleHighlight: 'phân tích thủy lực',
    titleEnd: 'Engine',
    heroDescription: 'Tính đường kính ống, vận tốc nước, số Reynolds và tổn thất cột áp ma sát Darcy-Weisbach theo hệ mét và hệ Anh.',
    quickPresets: 'Cài đặt nhanh',
    domesticWater: 'Đường ống cấp nước chính trong nhà (0.5 L/s)',
    chilledWater: 'Nhánh nước lạnh (3.0 L/s)',
    highRise: 'Ống đứng nhà cao tầng (8.0 L/s)',
    apply: 'Áp dụng',
    tabWater: '1. Tính kích thước ống nước',
    tabCopper: '2. Tính kích thước ống đồng',
    tabFlow: '3. Máy tính lưu lượng',
    tabPressure: '4. Tổn thất áp suất (Darcy)',
    tabVelocity: '5. Vận tốc và tiêu chuẩn đường ống',
    aboutLabel: 'Tiêu chuẩn và chứng nhận',
    aboutTitle: 'Giới thiệu PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com là công cụ kỹ thuật cơ khí độc lập dành cho tư vấn hệ thống tòa nhà, nhà thầu cơ khí và kỹ sư đường ống trên toàn thế giới.',
    standardsTitle: 'Tiêu chuẩn kỹ thuật tham khảo',
    standard1: 'Thông số kỹ thuật lắp đặt đường ống dẫn nước dùng cho con người bên trong các tòa nhà.',
    standard2: 'Y tế công cộng và kỹ thuật cấp thoát nước.',
    standard3: 'Ống thép và thép không gỉ hàn và không hàn.',
    standard4: 'Tiêu chuẩn kỹ thuật cho ống nước bằng đồng liền mạch (loại K, L, M).',
    noticeTitle: 'THÔNG BÁO KỸ THUẬT:',
    notice: 'Các phép tính của phần mềm này dành cho thiết kế sơ bộ, kiểm tra kích thước và ước tính giáo dục. Thiết kế cơ khí phải được kỹ sư có giấy phép kiểm tra theo quy chuẩn xây dựng địa phương.',
    toastDomestic: 'Đã áp dụng: Đường ống cấp nước chính',
    toastChilled: 'Đã áp dụng: Nhánh nước lạnh',
    toastHighRise: 'Đã áp dụng: Ống đứng nhà cao tầng',
  },

  it: {
    standardsBadge: 'Standard di ingegneria',
    titleStart: 'Dimensionamento internazionale dei tubi e',
    titleHighlight: 'analisi idraulica',
    titleEnd: 'Engine',
    heroDescription: 'Calcola diametri delle tubazioni, velocità dell’acqua, numeri di Reynolds e perdite di carico per attrito Darcy-Weisbach secondo gli standard metrici e imperiali.',
    quickPresets: 'Impostazioni rapide',
    domesticWater: 'Linea principale domestica (0.5 L/s)',
    chilledWater: 'Ramo acqua refrigerata (3.0 L/s)',
    highRise: 'Colonna montante edificio alto (8.0 L/s)',
    apply: 'Applica',
    tabWater: '1. Dimensionamento tubi acqua',
    tabCopper: '2. Dimensionamento tubi rame',
    tabFlow: '3. Calcolatore di portata',
    tabPressure: '4. Perdita di pressione (Darcy)',
    tabVelocity: '5. Velocità e standard dei tubi',
    aboutLabel: 'Standard e certificazione',
    aboutTitle: 'Informazioni su PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com è uno strumento indipendente di ingegneria meccanica per consulenti, appaltatori e ingegneri idraulici in tutto il mondo.',
    standardsTitle: 'Standard di ingegneria consultati',
    standard1: 'Specifiche per impianti interni che trasportano acqua destinata al consumo umano.',
    standard2: 'Sanità pubblica e ingegneria idraulica.',
    standard3: 'Tubi in acciaio e acciaio inossidabile saldati e senza saldatura.',
    standard4: 'Specifica standard per tubi in rame senza saldatura (tipi K, L, M).',
    noticeTitle: 'AVVISO DI INGEGNERIA:',
    notice: 'I calcoli di questo software sono destinati alla progettazione preliminare, alla verifica delle dimensioni e a stime didattiche. I progetti devono essere verificati da un ingegnere abilitato secondo le normative locali.',
    toastDomestic: 'Applicato: linea principale domestica',
    toastChilled: 'Applicato: ramo acqua refrigerata',
    toastHighRise: 'Applicato: colonna montante',
  },

  th: {
    standardsBadge: 'มาตรฐานวิศวกรรม',
    titleStart: 'การกำหนดขนาดท่อระดับสากลและ',
    titleHighlight: 'การวิเคราะห์ไฮดรอลิก',
    titleEnd: 'Engine',
    heroDescription: 'คำนวณเส้นผ่านศูนย์กลางท่อ ความเร็วการไหลของน้ำ ค่าเรย์โนลด์ และการสูญเสียเฮดจากแรงเสียดทาน Darcy-Weisbach ตามมาตรฐานเมตริกและอิมพีเรียล',
    quickPresets: 'การตั้งค่าด่วน',
    domesticWater: 'ท่อประปาหลักภายในบ้าน (0.5 L/s)',
    chilledWater: 'ท่อน้ำเย็นแยกสาขา (3.0 L/s)',
    highRise: 'ท่อแนวตั้งอาคารสูง (8.0 L/s)',
    apply: 'นำไปใช้',
    tabWater: '1. คำนวณขนาดท่อน้ำ',
    tabCopper: '2. คำนวณขนาดท่อทองแดง',
    tabFlow: '3. เครื่องคำนวณอัตราการไหล',
    tabPressure: '4. การสูญเสียแรงดัน (Darcy)',
    tabVelocity: '5. ความเร็วและมาตรฐานท่อ',
    aboutLabel: 'มาตรฐานและการรับรอง',
    aboutTitle: 'เกี่ยวกับ PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com เป็นเครื่องมือวิศวกรรมเครื่องกลอิสระสำหรับที่ปรึกษาระบบอาคาร ผู้รับเหมาเครื่องกล และวิศวกรระบบประปาทั่วโลก',
    standardsTitle: 'มาตรฐานวิศวกรรมที่ใช้อ้างอิง',
    standard1: 'ข้อกำหนดสำหรับระบบท่อภายในอาคารที่ลำเลียงน้ำสำหรับการบริโภคของมนุษย์',
    standard2: 'สาธารณสุขและวิศวกรรมระบบประปา',
    standard3: 'ท่อเหล็กและสเตนเลสแบบเชื่อมและไร้ตะเข็บ',
    standard4: 'ข้อกำหนดมาตรฐานสำหรับท่อน้ำทองแดงไร้ตะเข็บ (ชนิด K, L, M)',
    noticeTitle: 'ประกาศด้านวิศวกรรม:',
    notice: 'การคำนวณของซอฟต์แวร์นี้ใช้สำหรับการออกแบบเบื้องต้น การตรวจสอบขนาด และการประมาณเพื่อการศึกษา การออกแบบต้องได้รับการตรวจสอบโดยวิศวกรที่มีใบอนุญาตตามข้อกำหนดอาคารในท้องถิ่น',
    toastDomestic: 'ใช้แล้ว: ท่อประปาหลักภายในบ้าน',
    toastChilled: 'ใช้แล้ว: ท่อน้ำเย็นแยกสาขา',
    toastHighRise: 'ใช้แล้ว: ท่อแนวตั้งอาคารสูง',
  },

  nl: {
    standardsBadge: 'Technische normen',
    titleStart: 'Internationale leidingdimensionering en',
    titleHighlight: 'hydraulische analyse',
    titleEnd: 'Engine',
    heroDescription: 'Bereken leidingdiameters, watersnelheid, Reynoldsgetallen en Darcy-Weisbach-wrijvingsverlies volgens metrische en imperiale normen.',
    quickPresets: 'Snelle toepassingsinstellingen',
    domesticWater: 'Huishoudelijke hoofdwaterleiding (0.5 L/s)',
    chilledWater: 'Gekoeldwateraftakking (3.0 L/s)',
    highRise: 'Stijgleiding hoog gebouw (8.0 L/s)',
    apply: 'Toepassen',
    tabWater: '1. Waterleiding dimensioneren',
    tabCopper: '2. Koperen leiding dimensioneren',
    tabFlow: '3. Debietcalculator',
    tabPressure: '4. Drukverlies (Darcy)',
    tabVelocity: '5. Leiding­snelheid en normen',
    aboutLabel: 'Normen en certificering',
    aboutTitle: 'Over PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com is een onafhankelijk werktuigbouwkundig hulpmiddel voor adviseurs, aannemers en loodgietersingenieurs wereldwijd.',
    standardsTitle: 'Geraadpleegde technische normen',
    standard1: 'Specificaties voor installaties in gebouwen die water voor menselijke consumptie vervoeren.',
    standard2: 'Volksgezondheid en sanitairtechniek.',
    standard3: 'Gelaste en naadloze stalen en roestvaststalen leidingen.',
    standard4: 'Standaardspecificatie voor naadloze koperen waterleidingen (typen K, L, M).',
    noticeTitle: 'TECHNISCHE MEDEDELING:',
    notice: 'De berekeningen zijn bedoeld voor voorlopig ontwerp, maatcontrole en educatieve schattingen. Ontwerpen moeten worden gecontroleerd door een bevoegde ingenieur volgens de lokale bouwvoorschriften.',
    toastDomestic: 'Toegepast: huishoudelijke hoofdwaterleiding',
    toastChilled: 'Toegepast: gekoeldwateraftakking',
    toastHighRise: 'Toegepast: stijgleiding hoog gebouw',
  },

  pl: {
    standardsBadge: 'Normy inżynieryjne',
    titleStart: 'Międzynarodowy dobór rur i',
    titleHighlight: 'analiza hydrauliczna',
    titleEnd: 'Engine',
    heroDescription: 'Obliczaj średnice rur, prędkość przepływu wody, liczbę Reynoldsa i straty tarcia Darcy-Weisbach zgodnie z normami metrycznymi i imperialnymi.',
    quickPresets: 'Szybkie ustawienia',
    domesticWater: 'Główny przewód wody domowej (0.5 L/s)',
    chilledWater: 'Odgałęzienie wody lodowej (3.0 L/s)',
    highRise: 'Pion instalacyjny w wysokim budynku (8.0 L/s)',
    apply: 'Zastosuj',
    tabWater: '1. Dobór rur wodnych',
    tabCopper: '2. Dobór rur miedzianych',
    tabFlow: '3. Kalkulator przepływu',
    tabPressure: '4. Spadek ciśnienia (Darcy)',
    tabVelocity: '5. Prędkość przepływu i normy',
    aboutLabel: 'Normy i certyfikacja',
    aboutTitle: 'O PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com to niezależne narzędzie inżynierii mechanicznej dla konsultantów, wykonawców i inżynierów instalacji sanitarnych na całym świecie.',
    standardsTitle: 'Uwzględnione normy inżynieryjne',
    standard1: 'Specyfikacje instalacji wewnątrz budynków transportujących wodę przeznaczoną do spożycia przez ludzi.',
    standard2: 'Zdrowie publiczne i inżynieria sanitarna.',
    standard3: 'Spawane i bezszwowe rury stalowe oraz nierdzewne.',
    standard4: 'Standardowa specyfikacja bezszwowych miedzianych rur wodnych (typy K, L, M).',
    noticeTitle: 'INFORMACJA INŻYNIERYJNA:',
    notice: 'Obliczenia służą do wstępnego projektowania, weryfikacji wymiarów i celów edukacyjnych. Projekty musi sprawdzić uprawniony inżynier zgodnie z lokalnymi przepisami budowlanymi.',
    toastDomestic: 'Zastosowano: główny przewód wody domowej',
    toastChilled: 'Zastosowano: odgałęzienie wody lodowej',
    toastHighRise: 'Zastosowano: pion instalacyjny',
  },

  ur: {
    standardsBadge: 'انجینئرنگ معیارات',
    titleStart: 'بین الاقوامی پائپ سائزنگ اور',
    titleHighlight: 'ہائیڈرولک تجزیہ',
    titleEnd: 'انجن',
    heroDescription: 'میٹرک اور امپیریل معیارات کے مطابق پائپ کا قطر، پانی کے بہاؤ کی رفتار، رینالڈز نمبر اور Darcy-Weisbach رگڑ کے دباؤ کے نقصان کا حساب لگائیں۔',
    quickPresets: 'فوری ایپلیکیشن سیٹنگز',
    domesticWater: 'گھریلو پانی کی مرکزی لائن (0.5 L/s)',
    chilledWater: 'ٹھنڈے پانی کی شاخ (3.0 L/s)',
    highRise: 'اونچی عمارت کا رائزر (8.0 L/s)',
    apply: 'لاگو کریں',
    tabWater: '1. پانی کے پائپ کا سائز',
    tabCopper: '2. تانبے کے پائپ کا سائز',
    tabFlow: '3. بہاؤ کی شرح کیلکولیٹر',
    tabPressure: '4. دباؤ میں کمی (Darcy)',
    tabVelocity: '5. پائپ کی رفتار اور معیارات',
    aboutLabel: 'معیارات اور سرٹیفیکیشن',
    aboutTitle: 'PipeSizingCalculator.com کے بارے میں',
    aboutDescription: 'PipeSizingCalculator.com دنیا بھر کے بلڈنگ سروسز کنسلٹنٹس، مکینیکل کنٹریکٹرز اور پلمبنگ انجینئرز کے لیے ایک آزاد مکینیکل انجینئرنگ ٹول ہے۔',
    standardsTitle: 'استعمال کیے گئے انجینئرنگ معیارات',
    standard1: 'عمارتوں کے اندر انسانی استعمال کے پانی کی ترسیل کرنے والی تنصیبات کی وضاحتیں۔',
    standard2: 'عوامی صحت اور پلمبنگ انجینئرنگ۔',
    standard3: 'ویلڈڈ اور سیملیس اسٹیل اور اسٹینلیس اسٹیل پائپ۔',
    standard4: 'سیملیس تانبے کی پانی کی ٹیوب کے لیے معیاری وضاحت (اقسام K، L، M)۔',
    noticeTitle: 'انجینئرنگ نوٹس:',
    notice: 'اس سافٹ ویئر کے حسابات ابتدائی ڈیزائن، سائز کی تصدیق اور تعلیمی اندازوں کے لیے ہیں۔ ڈیزائن کی تصدیق مقامی بلڈنگ کوڈز کے مطابق لائسنس یافتہ انجینئر سے کروائیں۔',
    toastDomestic: 'لاگو کیا گیا: گھریلو پانی کی مرکزی لائن',
    toastChilled: 'لاگو کیا گیا: ٹھنڈے پانی کی شاخ',
    toastHighRise: 'لاگو کیا گیا: اونچی عمارت کا رائزر',
  },

  id: {
    standardsBadge: 'Standar Teknik',
    titleStart: 'Penentuan Ukuran Pipa Internasional &',
    titleHighlight: 'Analisis Hidraulik',
    titleEnd: 'Engine',
    heroDescription: 'Hitung diameter pipa, kecepatan aliran air, angka Reynolds, dan kehilangan tinggi gesek Darcy-Weisbach berdasarkan standar metrik dan imperial.',
    quickPresets: 'Preset Aplikasi Cepat',
    domesticWater: 'Pipa utama air rumah tangga (0.5 L/s)',
    chilledWater: 'Cabang air dingin (3.0 L/s)',
    highRise: 'Pipa tegak gedung tinggi (8.0 L/s)',
    apply: 'Terapkan',
    tabWater: '1. Penentuan Ukuran Pipa Air',
    tabCopper: '2. Penentuan Ukuran Pipa Tembaga',
    tabFlow: '3. Kalkulator Debit Aliran',
    tabPressure: '4. Penurunan Tekanan (Darcy)',
    tabVelocity: '5. Kecepatan dan Standar Pipa',
    aboutLabel: 'Standar dan Sertifikasi',
    aboutTitle: 'Tentang PipeSizingCalculator.com',
    aboutDescription: 'PipeSizingCalculator.com adalah alat teknik mesin independen untuk konsultan layanan gedung, kontraktor mekanik, dan insinyur perpipaan di seluruh dunia.',
    standardsTitle: 'Standar Teknik yang Digunakan',
    standard1: 'Spesifikasi instalasi di dalam gedung yang mengalirkan air untuk konsumsi manusia.',
    standard2: 'Kesehatan masyarakat dan teknik perpipaan.',
    standard3: 'Pipa baja dan baja tahan karat las maupun tanpa sambungan.',
    standard4: 'Spesifikasi standar untuk pipa air tembaga tanpa sambungan (tipe K, L, M).',
    noticeTitle: 'PEMBERITAHUAN TEKNIK:',
    notice: 'Perhitungan perangkat lunak ini ditujukan untuk desain awal, verifikasi ukuran, dan estimasi pendidikan. Desain harus diperiksa oleh insinyur profesional berlisensi sesuai peraturan bangunan setempat.',
    toastDomestic: 'Diterapkan: Pipa utama air rumah tangga',
    toastChilled: 'Diterapkan: Cabang air dingin',
    toastHighRise: 'Diterapkan: Pipa tegak gedung tinggi',
  },
};
